module.exports = __webpack_public_path__ + "img/7.4e9b1d71.jpg";